
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshan() {



  const cardData =
  {
    keyword: 'Pune to Konkan Darshan Cab',
    heading: 'AB Ghule Cabs: Pune to Konkan Darshan Cab',
    headingDescription: 'AB Ghule Cabs provides convenient, safe, and reliable Pune to Konkan Darshan cab services. Whether you are planning a family getaway, a religious trip, or a sightseeing tour, we ensure your journey is smooth and enjoyable. Our experienced drivers and well-maintained vehicles make it easier for you to explore the scenic beauty, culture, and historical significance of the Konkan region. Pune is approximately 200 km to 350 km from Konkan, depending on the specific destination within the Konkan region.',

    top: 'Top Places to Visit in Konkan with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Ganpatipule Temple",
          description: "Located in Ganpatipule, this temple is a renowned pilgrimage site dedicated to Lord Ganesha. Set against the backdrop of a serene beach, it offers a tranquil environment for devotees and visitors alike."
        },
        {
          title: "Alibaug Beach",
          description: "Alibaug Beach is famous for its pristine shores and scenic sunsets. It's a perfect spot for relaxation, water sports, and enjoying the beauty of the Konkan coastline."
        },
        {
          title: "Kunkeshwar Temple",
          description: "Situated in the Sindhudurg district, the Kunkeshwar Temple is dedicated to Lord Shiva. Known for its stunning architecture, it sits near a beautiful beach, providing a blend of spiritual and natural beauty."
        },
        {
          title: "Tarkarli Beach",
          description: "Tarkarli Beach is a haven for water sports enthusiasts, offering activities like snorkeling, scuba diving, and parasailing. Its crystal-clear waters and vibrant coral reefs make it a must-visit destination."
        },
        {
          title: "Sindhudurg Fort",
          description: "Sindhudurg Fort, built by Shivaji Maharaj, is a historical marvel located on an island. Surrounded by the Arabian Sea, it provides an intriguing glimpse into the Maratha empire's history."
        },
        {
          title: "Murud-Janjira Fort",
          description: "This well-preserved marine fort is located off the coast of Murud. Accessible by boat, it boasts historical significance and offers breathtaking views of the surrounding sea."
        },
        {
          title: "Dapoli Beach",
          description: "Dapoli Beach is known for its clean, golden sands and peaceful surroundings. It's an ideal destination for a quiet retreat and nature's serenity."
        },
        {
          title: "Rajmachi Fort",
          description: "Nestled in the Sahyadri mountain range, Rajmachi Fort is popular for trekking and its historical significance. It offers stunning panoramic views and is a favorite among adventure seekers."
        },
        {
          title: "Kihee Beach",
          description: "A hidden gem in the Konkan region, Kihee Beach is a secluded and tranquil spot surrounded by lush greenery. It's perfect for solitude and relaxation away from the crowds."
        },
        {
          title: "Harihareshwar Temple",
          description: "Located near the Arabian Sea, the Harihareshwar Temple is dedicated to Lord Shiva. Its peaceful setting and religious significance make it a popular destination for spiritual reflection."
        }
      ],


  services: [
    {
      "name": "Pune to Konkan Darshan Taxi Services",
      description: "Explore the scenic beauty of Konkan with AB Ghule Cabs’ premium taxi services. Our Pune to Konkan Darshan taxi services provide you with the convenience of traveling to beautiful beaches and landmarks along the Konkan coast. Travel comfortably with professional drivers who ensure a safe and enjoyable trip."
    },
    {
      "name": "Pune to Konkan Darshan Cab Booking",
      description: "Booking a cab from Pune to Konkan Darshan is simple and fast with AB Ghule Cabs. You can easily book your cab online or over the phone. Choose from a wide variety of vehicles, ensuring a comfortable and relaxed ride as you explore the stunning Konkan region."
    },
    {
      "name": "Pune to Konkan Darshan Car Rental",
      description: "Rent a car for your Konkan Darshan journey from Pune with AB Ghule Cabs. We offer a range of vehicles from sedans to SUVs, ideal for exploring the beautiful beaches and scenic spots along the Konkan coast. Whether you're traveling alone or in a group, we have the perfect vehicle for your needs."
    },
    {
      "name": "Pune to Konkan Darshan Chauffeur-Driven Cabs",
      description: "Experience the convenience and luxury of a chauffeur-driven cab for your Pune to Konkan Darshan trip. Our experienced drivers will guide you to the best spots along the Konkan coast, including the famous beaches and scenic viewpoints. Enjoy your holiday without worrying about navigation and driving."
    },
    {
      "name": "Pune to Konkan Darshan One-Way Taxi",
      description: "Looking for a one-way trip to Konkan? AB Ghule Cabs offers one-way taxi services for your Pune to Konkan Darshan journey. You’ll only pay for the distance traveled, offering you an economical and flexible travel option for a one-way trip to the coastal region."
    },
    {
      "name": "Pune to Konkan Darshan Round Trip Cabs",
      description: "Planning to visit multiple locations in Konkan? Our round-trip cabs are perfect for exploring the region at your leisure. Book a round-trip from Pune to Konkan Darshan and enjoy a comfortable, stress-free ride, with the flexibility to visit various beaches, forts, and scenic spots along the Konkan coast."
    },
    {
      "name": "Pune to Konkan Darshan Luxury Taxi",
      description: "For a more luxurious experience, opt for our luxury taxi services for your Pune to Konkan Darshan trip. Travel in comfort and style in our premium vehicles, designed to offer a high-end travel experience. With added amenities and luxury, you’ll enjoy the journey as much as the destination."
    },
    {
      "name": "Pune to Konkan Darshan Travel Packages",
      description: "AB Ghule Cabs offers customizable Konkan Darshan travel packages that include taxi services, sightseeing, and accommodations. Explore the beauty of the Konkan region with a hassle-free travel package that suits your preferences. Choose from various destinations like Alibaug, Tarkarli, and more."
    },
    {
      "name": "Pune to Konkan Darshan Private Car Hire",
      description: "If you prefer a more personalized travel experience, book a private car hire for your trip to Konkan. AB Ghule Cabs provides dedicated vehicles for you and your group, ensuring comfort, privacy, and convenience as you travel across the Konkan coast."
    },
    {
      "name": "Pune to Konkan Darshan Taxi Charges",
      description: "Our Pune to Konkan Darshan taxi charges are competitive and transparent. Depending on your choice of vehicle, travel duration, and destinations, we offer affordable pricing with no hidden fees. Get an accurate estimate of your trip’s cost when you book your cab."
    },
    {
      "name": "Pune to Alibaug Beach Taxi",
      description: "AB Ghule Cabs offers reliable taxi services for your trip from Pune to Alibaug Beach. Whether you're looking to relax on the beach or explore the nearby forts, our comfortable cabs will get you there safely and in style. Book a taxi for a convenient and memorable trip to Alibaug Beach."
    },
    {
      "name": "Pune to Tarkarli Beach Cab Fare",
      description: "Planning a beach trip to Tarkarli? AB Ghule Cabs provides affordable and comfortable taxi services for your journey from Pune to Tarkarli Beach. Our competitive cab fares make it easy to visit one of the most beautiful beaches in Maharashtra."
    },
    {
      "name": "Pune to Kashid Beach Cabs",
      description: "Discover the beauty of Kashid Beach with AB Ghule Cabs. Our taxi services offer a comfortable and hassle-free ride from Pune to Kashid, one of the most serene and clean beaches in Maharashtra. Whether you're planning a day trip or a longer stay, we have the right taxi for your journey."
    },
    {
      "name": "Pune to Malvan Beach Taxi Service",
      description: "Travel from Pune to Malvan Beach with AB Ghule Cabs for a relaxing and scenic journey. Our taxi services ensure you arrive at the beach comfortably and on time. Enjoy the coastal beauty of Malvan Beach with our safe and affordable taxi service."
    },
    {
      "name": "Pune to Diveagar Beach Tempo Traveller",
      description: "Traveling in a group? Our tempo traveller service is ideal for large groups traveling from Pune to Diveagar Beach. With ample space and comfortable seating, our tempo travellers ensure that everyone travels together comfortably while enjoying the sights along the way."
    },
    {
      "name": "Pune to Ganpatipule Beach Cab Service",
      description: "Visit the picturesque Ganpatipule Beach with AB Ghule Cabs. Our taxi services provide a comfortable ride from Pune to Ganpatipule, ensuring that you can enjoy the scenic views and pristine beaches without the hassle of driving. Book your cab today for a memorable experience."
    },
    {
      "name": "Pune to Ratnagiri Cab Service",
      description: "AB Ghule Cabs offers reliable cab services for your trip from Pune to Ratnagiri, a coastal gem known for its beaches and forts. Travel in comfort and explore the beauty of this destination with our affordable and convenient taxi services."
    },
    {
      "name": "Pune to Harihareshwar Beach Taxi Service",
      description: "Planning a trip to Harihareshwar Beach? AB Ghule Cabs provides taxi services for your journey from Pune to this serene beach. Our experienced drivers will ensure that you enjoy a smooth, hassle-free ride as you head to this peaceful coastal destination."
    },
    {
      "name": "Pune to Konkan Darshan Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Konkan Darshan Cabs. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Konkan Darshan Taxi Services", "-Pune to Konkan Darshan Cab Booking"],
    ["Pune to Konkan Darshan Car Rental", "-Pune to Konkan Darshan Chauffeur-Driven Cabs"],
    ["Pune to Konkan Darshan One-Way Taxi", "-Pune to Konkan Darshan Round Trip Cabs"],
    ["Pune to Konkan Darshan Luxury Taxi", "-Pune to Konkan Darshan Travel Packages"],
    ["Pune to Konkan Darshan Private Car Hire", "-Pune to Konkan Darshan Taxi Charges"],
    ["Pune to Alibaug Beach Taxi", "-Pune to Tarkarli Beach Cab Fare"],
    ["Pune to Kashid Beach Cabs", "-Pune to Malvan Beach Taxi Service"],
    ["Pune to Diveagar Beach Tempo Traveller", "-Pune to Ganpatipule Beach Cab Service"],
    ["Pune to Ratnagiri Cab Service", "-Pune to Harihareshwar Beach Taxi Service"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Scenic and Relaxing Journey",
      WhyChoosedescription: "AB Ghule Cabs offers a beautiful and comfortable ride from Pune to Konkan. Experience the stunning landscapes, coastal views, and lush greenery along the Konkan coast, all from the comfort of our well-maintained vehicles."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our professional and experienced drivers are well-versed in the routes of Konkan and are committed to providing a safe and enjoyable journey. They ensure smooth travel while prioritizing your comfort and safety."
    },
    {
      WhyChooseheading: "Comfortable and Well-Maintained Fleet",
      WhyChoosedescription: "We offer a variety of vehicles, including sedans, SUVs, and luxury cars, equipped with air-conditioning, spacious seating, and other amenities to make your journey from Pune to Konkan enjoyable and stress-free."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "AB Ghule Cabs provides affordable and transparent pricing for your Pune to Konkan Darshan trip. With no hidden charges, we ensure you get value for your money, regardless of whether you are traveling solo or with a group."
    },
    {
      WhyChooseheading: "Customizable Packages for Konkan Darshan",
      WhyChoosedescription: "We offer flexible and customizable travel packages for Konkan Darshan, allowing you to explore multiple destinations along the Konkan coast, such as Alibaug, Ganpatipule, Tarkarli, and more."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether you need an early morning start or a late evening ride, we are available 24/7. Book your cab at any time and enjoy seamless travel to Konkan from Pune with our round-the-clock service."
    },
    {
      WhyChooseheading: "Well-Equipped Vehicles",
      WhyChoosedescription: "Our vehicles are regularly serviced and equipped with modern features like GPS navigation and mobile chargers. You can rely on our vehicles for a safe and smooth journey to your Konkan destination."
    },
    {
      WhyChooseheading: "Customer Satisfaction Focused",
      WhyChoosedescription: "We prioritize customer satisfaction with prompt support, excellent service, and hassle-free bookings. Our goal is to make your trip to Konkan comfortable, enjoyable, and memorable."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab for Pune to Konkan Darshan?',
      answer: 'You can easily book a cab via our website, mobile app, or by calling our customer service. We offer multiple options for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for Pune to Konkan Darshan?',
      answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars, depending on your preference and group size for the trip.',
    },
    {
      id: 'FAQ3',
      question: 'Are the drivers familiar with the Konkan route?',
      answer: 'Yes, our drivers are experienced and well-versed in the Konkan route. They know the best roads, scenic stops, and are familiar with the local culture and attractions along the way.',
    },
    {
      id: 'FAQ4',
      question: 'How long does the journey from Pune to Konkan take?',
      answer: 'The journey from Pune to Konkan typically takes around 5-7 hours, depending on the exact destination and road conditions. However, you can enjoy the scenic beauty along the route.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for sightseeing or detours in Konkan?',
      answer: 'We offer customizable packages for sightseeing and detours in Konkan. Additional charges for sightseeing or detours will be discussed and confirmed during booking, ensuring transparency.',
    },
    {
      id: 'FAQ6',
      question: 'How do I pay for my ride from Pune to Konkan?',
      answer: 'We provide flexible payment options, including cash, credit/debit cards, and online payments via our mobile app, making the payment process convenient for you.',
    },
    {
      id: 'FAQ7',
      question: 'Can I book a round-trip for Pune to Konkan Darshan?',
      answer: 'Yes, you can book a round-trip cab for your Pune to Konkan journey. Our team will help you customize your trip and plan your return journey as per your convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Can I make stops along the way to Konkan?',
      answer: 'Yes, you can request stops for refreshments, sightseeing, or to explore certain spots along the way. Our drivers will make the necessary arrangements, ensuring a smooth trip.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any luggage limits for the trip to Konkan?',
      answer: 'Our vehicles have ample space for luggage. If you have special requirements, such as extra luggage or specific items, please inform us during the booking process, and we’ll make necessary arrangements.',
    },
    {
      id: 'FAQ10',
      question: 'Why should I choose AB Ghule Cabs for Pune to Konkan Darshan?',
      answer: 'AB Ghule Cabs stands out for its reliable, comfortable, and safe service, affordable pricing, well-maintained vehicles, and experienced drivers. We ensure a memorable and enjoyable journey from Pune to Konkan.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Raghav Desai',
      feedback: 'I recently booked AB Ghule Cabs for a trip from Pune to Konkan, and the experience was exceptional. The car was clean, comfortable, and the driver was friendly and professional. He ensured we stopped at the most beautiful spots along the way. Highly recommend them for Konkan Darshan trips!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Mrs. Neha Patil',
      feedback: 'Our family had a wonderful trip to Konkan from Pune with AB Ghule Cabs. The driver was well-acquainted with the route and took us to some amazing places in Konkan. The journey was smooth, and the vehicle was well-maintained. We will definitely book with AB Ghule Cabs again.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Konkan Darshan Cabs | Affordable & Comfortable</title>
  <meta name="description" content="Book Pune to Konkan Darshan cab services with AB Ghule Cabs. Affordable, reliable, and comfortable one-way and round-trip taxi options for Konkan beaches and other destinations. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Konkan Darshan Taxi Services, Pune to Konkan Darshan Cab Booking, Pune to Konkan Darshan Car Rental, Pune to Konkan Darshan Chauffeur-Driven Cabs, Pune to Konkan Darshan One-Way Taxi, Pune to Konkan Darshan Round Trip Cabs, Pune to Konkan Darshan Luxury Taxi, Pune to Konkan Darshan Travel Packages, Pune to Konkan Darshan Private Car Hire, Pune to Konkan Darshan Taxi Charges, Pune to Alibaug Beach Taxi, Pune to Tarkarli Beach Cab fare, Pune to Kashid Beach Cabs, Pune to Malvan Beach Taxi Service, Pune to Diveagar Beach Tempo Traveller, Pune to Ganpatipule Beach Cab Service, Pune to Ratnagiri cab service, Pune to Harihareshwar beach taxi service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Konkan Darshan Cabs | Affordable & Comfortable" />
  <meta property="og:description" content="Book Pune to Konkan Darshan cab services with AB Ghule Cabs. Affordable, reliable, and comfortable one-way and round-trip taxi options for Konkan beaches and other destinations. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-konkan-darshan-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-konkan-darshan-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Konkan Darshan Cabs",
        description: "Book Pune to Konkan Darshan cab services with AB Ghule Cabs. Affordable, reliable, and comfortable one-way and round-trip taxi options for Konkan beaches and other destinations. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-konkan-darshan-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-konkan-darshan-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-konkan-darshan-cabs.jpg",
        "priceRange": "₹3500 - ₹7000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-konkan-darshan-cabs",
          "priceCurrency": "INR",
          "price": "3500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1100"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha Deshmukh"
            },
            "datePublished": "2024-12-10",
            "reviewBody": "A wonderful experience. Our trip to the Konkan beaches was made easy and comfortable. The driver was polite and knowledgeable."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh Naik"
            },
            "datePublished": "2024-12-02",
            "reviewBody": "Affordable rates and excellent service. Our family had a great time exploring Konkan. Highly recommended!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Konkan",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-konkan-darshan-cabs"
        },
        "keywords": "Pune to Konkan Darshan Taxi Services, Pune to Konkan Darshan Cab Booking, Pune to Konkan Darshan Car Rental, Pune to Konkan Darshan Chauffeur-Driven Cabs, Pune to Konkan Darshan One-Way Taxi, Pune to Konkan Darshan Round Trip Cabs, Pune to Konkan Darshan Luxury Taxi, Pune to Konkan Darshan Travel Packages, Pune to Konkan Darshan Private Car Hire, Pune to Konkan Darshan Taxi Charges, Pune to Alibaug Beach Taxi, Pune to Tarkarli Beach Cab fare, Pune to Kashid Beach Cabs, Pune to Malvan Beach Taxi Service, Pune to Diveagar Beach Tempo Traveller, Pune to Ganpatipule Beach Cab Service, Pune to Ratnagiri cab service, Pune to Harihareshwar beach taxi service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/23.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetokonkandarshan;